export const patfeedbackColumn = [
    {
      label: '序号',
      align: 'center',
      size: 'mini',
      width: '50px',
      render: (h, scope) => {
        return <span slot="reference">{scope.$index * 1 + 1}</span>
      },
    },
    {
      label: '问卷名称',
      align: 'center',
      prop: 'conent',
      size: 'mini',
    },
    {
      label: '问卷类型',
      align: 'center',
      prop: 'tagName',
      size: 'mini',
    },
    {
      label: '反馈时间',
      align: 'center',
      prop: 'feedbackTime',
      size: 'mini',
    },
    {
      label: '操作',
      align: 'center',
      prop: 'operation',
      size: 'mini',
      slotScope: 'operation'
    }
]
